import { Event } from '~/Features/Messaging/types';
import type { TabKey } from '~/Partials/TabList/Tab';

export class TabSwitched extends Event {
    public static readonly id = 'TabSwitched';

    constructor(public tabKey: TabKey) {
        super(TabSwitched.id);
    }
}
